<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { useClassStore } from '../../stores';
import { ClassViewMode, classViewModeMap } from '../../types/class';
import Button from '../General/Button.vue';

const classStore = useClassStore()
const handleChangeViewMode = (viewMode: ClassViewMode) => {
    classStore.viewMode = viewMode
}

const { t } = useI18n()
</script>

<template>
    <div class="flex items-center bg-sky-400 rounded-lg">
        <Button v-for="viewMode in ClassViewMode" :shadow="false"
            :color="viewMode === classStore.viewMode ? 'secondary' : 'info'" class="border-none"
            @click="handleChangeViewMode(viewMode)">
            <span v-if="viewMode === classStore.viewMode" class="size-2 rounded-full bg-white"></span>
            {{ t(classViewModeMap[viewMode]) }}
        </Button>
    </div>
</template>